<template>
  <div
    id="history"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div
          class="sticky-top container-fluid"
          data-padding-right=""
          data-margin-right=""
          style=""
        >
          <div
            class="align-items-center justify-content-center py-0 modalTopClose row"
          >
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="font-size: 20px;"
                >
                  <path
                    fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img
                    alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์"
                    loading="eager"
                    width="190"
                    height="48"
                    decoding="async"
                    data-nimg="1"
                    class="animated fadeInUp img-fluid"
                    src="/static/img/logo/logo.png"
                    style="color: transparent;"
                  />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img
                  src="/static/img/landing/closeIcon.png"
                  width="40"
                  height="40"
                  alt="ปิด"
                  class=""
                />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>ประวัติ</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  @click="tab = 1"
                  type="button"
                  id="v-pills-dps"
                  role="tab"
                  href="#v-pills-dps"
                  data-rr-ui-event-key="deposit"
                  aria-controls="v-pills-dps"
                  aria-selected="false"
                  class="nav-link "
                  :class="{'active':tab == 1}"
                  tabindex="-1"
                >
                  <span
                    ><svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="folder-plus"
                      class="svg-inline--fa fa-folder-plus "
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
                      ></path>
                    </svg>
                    ฝาก</span
                  >
                  </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                 @click="tab = 2"
                  type="button"
                  id="v-pills-wd"
                  role="tab"
                  href="#v-pills-wd"
                  data-rr-ui-event-key="withdraw"
                  aria-controls="v-pills-wd"
                  aria-selected="false"

                  tabindex="-1"
                  class="nav-link"
                  :class="{'active':tab == 2}"
                >
                  <span
                    ><svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="folder-minus"
                      class="svg-inline--fa fa-folder-minus "
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
                      ></path>
                    </svg>
                    ถอน</span
                  >
                  </button>
              </li>
            </ul>

            <div class="row mt-3">
              <div class="col-12 p-0 containhislist">
                <div id="v-pills-tabContent" class="tab-content">
                  <div
                    id="v-pills-dps"
                    role="tabpanel"
                    aria-labelledby="v-pills-dps-tab"
                    class="tab-pane fade   show"
                    :class="{'active':tab == 1}"

                  >
                    <div class="containerhis history-scroll">
                      <div class="row">
                        <div class="col-12 mx-auto  text-center">
                          <span v-if="depositList.length == 0"
                            >ไม่มีข้อมูล</span
                          >
                          <table
                            id="history-content-deposit"
                            class="table dataTable no-footer"
                            width="100%"
                            role="grid"
                            style="width: 100%;"
                            v-if="depositList.length > 0"
                          >
                            <thead>
                              <tr role="row">
                                <th>
                                  จำนวน
                                </th>
                                <th>
                                  เวลา
                                </th>
                                <th>
                                  ประเภท
                                </th>
                                <th>
                                  สถานะ
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(data, i) in depositList"
                                v-bind:key="i"
                                role="row"
                              >
                                <td>{{ data.Amount | formatNumber }} บาท</td>
                                <td>
                                  {{ getDate(data.createdAt) }}
                                </td>

                                <td>
                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-if="data.BonusInfo._id == 'ITEMCODE'"
                                  >
                                    เครดิตฟรี
                                  </span>
                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-else-if="data.BonusInfo._id == null"
                                  >
                                    ไม่รับโบนัส
                                  </span>
                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-else-if="
                                      data.BonusInfo._id != null &&
                                        data.BonusInfo._id != 'ITEMCODE'
                                    "
                                  >
                                    รับโบนัส
                                  </span>
                                </td>

                                <td>
                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-if="data.Status == 0"
                                  >
                                    อนุมัติ
                                  </span>

                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-if="data.Status == 1"
                                  >
                                    อนุมัติ
                                  </span>

                                  <span
                                    class="badge rounded-pill .bg-light"
                                    v-if="data.Status == 2"
                                  >
                                    รอดำเนินการ
                                  </span>

                                  <span
                                    class="badge rounded-pill bg-danger"
                                    v-if="data.Status == 3"
                                  >
                                    ล้มเหลว
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="v-pills-wd"
                    role="tabpanel"
                    aria-labelledby="v-pills-wd-tab"
                    :class="{'active show':tab == 2}"

                    class="tab-pane fade"
                  >
                    <div class="containerhis history-scroll">
                      <div class="row">
                        <div class="col-12 mx-auto  text-center">
                          <span v-if="withdrawList.length == 0"
                            >ไม่มีข้อมูล</span
                          >
                          <table
                            id="history-content-withdraw"
                            class="table dataTable no-footer"
                            width="100%"
                            role="grid"
                            style="width: 100%;"
                            v-if="withdrawList.length > 0"
                          >
                            <thead>
                              <tr role="row">
                                <th>
                                  จำนวน
                                </th>
                                <th>
                                  เวลา
                                </th>
                                <th>
                                  สถานะ
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, i) in withdrawList"
                                v-bind:key="i"
                                role="row"
                              >
                                <td>{{ data.Amount | formatNumber }} บาท</td>
                                <td>
                                  {{ getDate(data.createdAt) }}
                                </td>
                                <td>
                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-if="data.Status == 0"
                                  >
                                    <i class="fas fa-check-circle"></i>
                                    อนุมัติ
                                  </span>

                                  <span
                                    class="badge rounded-pill bg-success"
                                    v-if="data.Status == 1"
                                  >
                                    <i class="fas fa-check-circle"></i>
                                    อนุมัติ
                                  </span>

                                  <span
                                    class="badge rounded-pill .bg-light"
                                    v-if="data.Status == 2"
                                  >
                                    <i class="fas fa-check-circle"></i>
                                    รอดำเนินการ
                                  </span>

                                  <span
                                    class="badge rounded-pill bg-danger"
                                    v-if="data.Status == 3"
                                  >
                                    <i class="fas fa-check-circle"></i>
                                    ล้มเหลว
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="v-pills-hisreturn_balance"
                    role="tabpanel"
                    aria-labelledby="v-pills-hisreturn_balance-tab"
                    class="tab-pane fade"
                  >
                    <div class="containerhis history-scroll">
                      <div class="row">
                        <div class="col-12 mx-auto  text-center">
                          <span>ไม่มีข้อมูล</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="v-pills-hisreturn_deposit"
                    role="tabpanel"
                    aria-labelledby="v-pills-hisreturn_deposit-tab"
                    class="tab-pane fade"
                  >
                    <div class="containerhis history-scroll">
                      <div class="row">
                        <div class="col-12 mx-auto  text-center">
                          <span>ไม่มีข้อมูล</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { fetchDeposit } from "@/services/modules/deposit.js";
import { Initialize } from "@/services/modules/withdraw.js";
import { fetchTran } from "@/services/modules/history.js";

import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";

import moment from "moment";
export default {
  name: "HistoryForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],
  data() {
    return { depositList: [], withdrawList: [], Transfer: [], tab: 1 };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },

    async fetchTransfer() {
      await fetchTran((res) => {
        console.log("fetchTransfer");
        console.log(res.data);

        if (res.status) {
          this.Transfer = res.data;
        } else {
        }
      });
    },

    async fetchDeposit() {
      await fetchDeposit((res) => {
        if (res.status) {
          console.log("fetchDeposit");
          console.log(res);
          this.depositList = res.data;
        } else {
        }
      });
    },
    async fetchWithdraw() {
      await Initialize((res) => {
        console.log("fetchWithdraw");
        console.log(res.data.Transaction);

        if (res.status) {
          this.withdrawList = res.data.Transaction;
        } else {
        }
      });
    },
  },
  async mounted() {
    await this.fetchTransfer();
    await this.fetchDeposit();
    await this.fetchWithdraw();
  },
};
</script>
<style scoped>
.leftdps .nav-link {
  color: #fff;
}

.nav-tabs .nav-link {
     color: #fff;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #495057 !important ;
 
}
.tab-content>.active {
    display: block;
    background: #0000007d;
    color: #ffffff;
}
.table {
   
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/HistoryForm.vue